// @greenlight-spec: 19-design-system.md
// @greenlight-spec: 28-it-dashboard-ui.md
import * as React from 'react';

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

export type KnowledgeScopeValue = 'org' | 'integration' | 'app';

export interface ScopeSegmentsProps {
  scope: KnowledgeScopeValue;
  counts: Record<KnowledgeScopeValue, number | null>;
  onChange: (scope: KnowledgeScopeValue) => void;
}

const SEGMENTS: { value: KnowledgeScopeValue; label: string }[] = [
  { value: 'org', label: 'Org' },
  { value: 'integration', label: 'Integrations' },
  { value: 'app', label: 'Apps' },
];

export function ScopeSegments({ scope, counts, onChange }: ScopeSegmentsProps): React.JSX.Element {
  return (
    <Tabs
      value={scope}
      onValueChange={(v) => onChange(v as KnowledgeScopeValue)}
      activationMode="manual"
    >
      <TabsList
        aria-label="Knowledge scope"
        className="flex h-auto justify-start gap-2 overflow-x-auto rounded-none bg-transparent p-0 text-foreground [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      >
        {SEGMENTS.map((s) => (
          <TabsTrigger
            key={s.value}
            value={s.value}
            data-testid={`knowledge-tab-${s.value}`}
            className="-mb-px h-11 shrink-0 gap-1.5 rounded-none border-b-[3px] border-transparent px-3 text-sm font-medium text-foreground hover:border-border data-[state=active]:border-foreground data-[state=active]:bg-transparent data-[state=active]:font-bold data-[state=active]:shadow-none data-[state=active]:ring-0"
          >
            {s.label}
            {counts[s.value] != null && (
              <span className="font-mono text-[11px] font-normal tabular-nums text-muted-foreground">
                {counts[s.value]}
              </span>
            )}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
